import { getRandomAlphaNumericString } from "../../../utility/Utility";

export default class Template5 {
  static getData() {
    return {
      metaData: null,
      scripts: null,
      hash: getRandomAlphaNumericString(),
      designElements: [
        {
          type: "Text",
          value:
            "INFORM CANDIDATE THEY ARE NOT AMONG FIRST TIER TO BE INTERVIEWED BUT ARE STILL VIABLE FOR POSSIBLE CONSIDERATION",
          style: {
            width: "fit-content",
            boxSizing: "border-box",
            fontSize: 18,
            color: "#000000",
            textAlign: "center",
            fontWeight: "bold",
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 6,
            paddingRight: 6,
            marginTop: 10,
            marginBottom: 16,
            marginLeft: "auto",
            marginRight: "auto",
            borderRadius: 0,
            backgroundColor: "transparent",
            overflow: "hidden",
            alignSelf: "center",
            whiteSpace: "pre-wrap"
          },
        },
        {
          type: "Text",
          value:
            "Date",
          style: {
            width: "fit-content",
            boxSizing: "border-box",
            fontSize: 18,
            color: "#000000",
            textAlign: "left",
            fontWeight: "normal",
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 6,
            paddingRight: 6,
            marginTop: 10,
            marginBottom: 0,
            marginLeft: "",
            marginRight: "",
            borderRadius: 0,
            backgroundColor: "transparent",
            overflow: "hidden",
            alignSelf: "left",
            whiteSpace: "pre-wrap"
          },
        },
        {
          type: "Text",
          value:
            "Address",
          style: {
            width: "fit-content",
            boxSizing: "border-box",
            fontSize: 18,
            color: "#000000",
            textAlign: "left",
            fontWeight: "normal",
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 6,
            paddingRight: 6,
            marginTop: 0,
            marginBottom: 0,
            marginLeft: "",
            marginRight: "",
            borderRadius: 0,
            backgroundColor: "transparent",
            overflow: "hidden",
            alignSelf: "left",
            whiteSpace: "pre-wrap"
          },
        },
        {
          type: "Text",
          value:
            "Dear",
          style: {
            width: "fit-content",
            boxSizing: "border-box",
            fontSize: 18,
            color: "#000000",
            textAlign: "left",
            fontWeight: "normal",
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 6,
            paddingRight: 6,
            marginTop: 26,
            marginBottom: 0,
            marginLeft: "",
            marginRight: "",
            borderRadius: 0,
            backgroundColor: "transparent",
            overflow: "hidden",
            alignSelf: "left",
            whiteSpace: "pre-wrap"
          },
        },
        {
          type: "Text",
          value:
            "All of the complete candidate files for the position of ________________ at the University of Wisconsin-Stevens Point have been reviewed by the search and screen committee.  Due to the large number of well-qualified applicants, screening to identify those who are most highly qualified has been difficult.",
          style: {
            width: "fit-content",
            boxSizing: "border-box",
            fontSize: 18,
            color: "#000000",
            textAlign: "left",
            fontWeight: "normal",
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 6,
            paddingRight: 6,
            marginTop: 6,
            marginBottom: 0,
            marginLeft: "",
            marginRight: "",
            borderRadius: 0,
            backgroundColor: "transparent",
            overflow: "hidden",
            alignSelf: "left",
            whiteSpace: "pre-wrap"
          },
        },
        {
          type: "Text",
          value:
            "Your application is still under active consideration.  However, after careful review of the applicants, the search committee has narrowed the pool, and we are inviting ____ candidates to our campus for interviews.  We regret that you are not among the finalists, but we have not eliminated your application.  We are holding it along with several others in the event the interviews do not lead us to a successful conclusion.",
          style: {
            width: "fit-content",
            boxSizing: "border-box",
            fontSize: 18,
            color: "#000000",
            textAlign: "left",
            fontWeight: "normal",
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 6,
            paddingRight: 6,
            marginTop: 0,
            marginBottom: 0,
            marginLeft: "",
            marginRight: "",
            borderRadius: 0,
            backgroundColor: "transparent",
            overflow: "hidden",
            alignSelf: "left",
            whiteSpace: "pre-wrap"
          },
        },
        {
          type: "Text",
          value:
            "We appreciate your interest in the position and will keep you informed regarding the status of your application.",
          style: {
            width: "fit-content",
            boxSizing: "border-box",
            fontSize: 18,
            color: "#000000",
            textAlign: "left",
            fontWeight: "normal",
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 6,
            paddingRight: 6,
            marginTop: 0,
            marginBottom: 0,
            marginLeft: "",
            marginRight: "",
            borderRadius: 0,
            backgroundColor: "transparent",
            overflow: "hidden",
            alignSelf: "left",
            whiteSpace: "pre-wrap"
          },
        },
        {
          type: "Text",
          value:
            "Sincerely,",
          style: {
            width: "fit-content",
            boxSizing: "border-box",
            fontSize: 18,
            color: "#000000",
            textAlign: "left",
            fontWeight: "normal",
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 6,
            paddingRight: 6,
            marginTop: 18,
            marginBottom: 0,
            marginLeft: "",
            marginRight: "",
            borderRadius: 0,
            backgroundColor: "transparent",
            overflow: "hidden",
            alignSelf: "left",
            whiteSpace: "pre-wrap"
          },
        },
        {
          type: "Text",
          value:
            "NAME OF CHAIR OF SEARCH & SCREEN COMMITTEE",
          style: {
            width: "fit-content",
            boxSizing: "border-box",
            fontSize: 16,
            color: "#000000",
            textAlign: "left",
            fontWeight: "normal",
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 6,
            paddingRight: 6,
            marginTop: 20,
            marginBottom: 0,
            marginLeft: "",
            marginRight: "",
            borderRadius: 0,
            backgroundColor: "transparent",
            overflow: "hidden",
            alignSelf: "left",
            whiteSpace: "pre-wrap"
          },
        },
        {
          type: "Text",
          value:
            "Enclosure",
          style: {
            width: "fit-content",
            boxSizing: "border-box",
            fontSize: 18,
            color: "#000000",
            textAlign: "left",
            fontWeight: "normal",
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 6,
            paddingRight: 6,
            marginTop: 0,
            marginBottom: 0,
            marginLeft: "",
            marginRight: "",
            borderRadius: 0,
            backgroundColor: "transparent",
            overflow: "hidden",
            alignSelf: "left",
            whiteSpace: "pre-wrap"
          },
        }
      ],
    };
  }
}
